import {isPast, isAfter, isBefore, isEqual, startOfDay, endOfDay} from 'date-fns';

import { EventDateSummary } from 'context/types';
import { IEvent } from 'interfaces/IEvent';

export type ResolvedEvent = IEvent | EventDateSummary;

export const filterBySameDay = <T extends ResolvedEvent>(events: T[], selectedDate: Date): T[] => {
    return events.filter((event) => {
        // Handle null values: if ends is null, use starts; if starts is null, use ends
        const startDate = event.starts ? new Date(event.starts) : (event.ends ? new Date(event.ends) : null);
        const endDate = event.ends ? new Date(event.ends) : (event.starts ? new Date(event.starts) : null);

        // If both dates are null, skip this event
        if (!startDate || !endDate) {
            return false;
        }

        return isDateInRangeInclusive(selectedDate, { start: startDate, end: endDate });
    });
};

export const filterByMarkColor = (events: ResolvedEvent[], isMark: boolean) => {
    if (!isMark) {
        return undefined;
    }

    // All events end date is in the past
    const allEventsInPast = !events.some((event) => event.ends === null || !isPast(new Date(event.ends)));
    if (allEventsInPast) {
        return 'past';
    }

    // Some events haven't ended yet
    return events.some((event) => event.ticket_status !== 'SOLD_OUT') ? 'open' : 'closed';
};

export const isDateInRangeInclusive = (date: Date, range: { start: Date, end: Date }) => {
    // For "same day" filtering, we need to check if the event overlaps with the selected day
    // The event overlaps with the selected day if:
    // 1. Event starts before the end of the selected day AND
    // 2. Event ends after the start of the selected day

    const selectedDayStart = startOfDay(date);
    const selectedDayEnd = endOfDay(date);

    const eventOverlapsWithDay = (
        isBefore(range.start, selectedDayEnd) || isEqual(range.start, selectedDayEnd)
    ) && (
        isAfter(range.end, selectedDayStart) || isEqual(range.end, selectedDayStart)
    );

    return eventOverlapsWithDay;
};
